<template>
    <div class="main">
        <div class="left">
            <el-menu
                    class="el-menu-vertical-demo"
                    background-color="#545c64"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    :collapse="menuCollapse"
                    :router="true"
                    :unique-opened="true"
                    default-active="/"
            >
                <el-menu-item index="1" class="logo">
<!--                    <img :src="require('../assets/images/logo.png')"/>-->
<!--                    <i class="el-icon-menu"> </i>-->
                    <span slot="title" style="margin-left: .5rem">管理后台</span>
                </el-menu-item>

                <el-menu-item index="/banner">
                    <i class="el-icon-picture-outline"> </i>
                    <span slot="title">banner图</span>
                </el-menu-item>

                <el-submenu index="1">
                    <template slot="title">
                        <i class="el-icon-s-flag"> </i>
                        <span>内容管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/companyIntro" >公司介绍</el-menu-item>
                        <el-menu-item index="/productIntro" >产品介绍</el-menu-item>
                        <el-menu-item index="/guide" >使用说明</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="2">
                    <template slot="title">
                        <i class="el-icon-s-home"> </i>
                        <span>企业管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/enterprise" @click="clearPage">企业列表</el-menu-item>
                        <el-menu-item index="/deviceType" @click="clearPage">设备类型</el-menu-item>
                        <el-menu-item index="/deviceStandard" @click="clearPage">客户设备状态</el-menu-item>
                        <el-menu-item index="/device" @click="clearPage">客户处设备</el-menu-item>
                        <el-menu-item index="/epUser" @click="clearPage" v-if="auth.accountType != 1">企业账户</el-menu-item>
                        <el-menu-item index="/useinfo" @click="clearPage">使用信息</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-menu-item index="/order" @click="clearPage">
                    <i class="el-icon-s-order"> </i>
                    <span slot="title">订单列表</span>
                </el-menu-item>

                <el-menu-item index="/user" @click="clearPage">
                    <i class="el-icon-user"> </i>
                    <span slot="title">用户列表</span>
                </el-menu-item>

                <el-menu-item index="/account" @click="clearPage" v-if="auth.accountType == 3">
                    <i class="el-icon-s-custom"> </i>
                    <span slot="title">管理员列表</span>
                </el-menu-item>

               <!-- <el-menu-item index="/enterprise">
                    <i class="el-icon-s-home"> </i>
                    <span slot="title">企业列表</span>
                </el-menu-item>

                <el-menu-item index="/device">
                    <i class="el-icon-mobile"> </i>
                    <span slot="title">设备列表</span>
                </el-menu-item>

                <el-menu-item index="/account">
                    <i class="el-icon-s-custom"> </i>
                    <span slot="title">账户列表</span>
                </el-menu-item>-->

                <el-menu-item index="/report" @click="clearPage">
                    <i class="el-icon-edit-outline"> </i>
                    <span slot="title">报修列表</span>
                </el-menu-item>

                <el-submenu index="system-settings" v-if="auth.accountType == 3">
                    <template slot="title">
                        <i class="el-icon-setting"> </i>
                        <span>系统设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/deviceConfig" >设备参数</el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="/useinfoCycleConfig" >使用记录保存周期</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

            </el-menu>
        </div>
        <div class="right">
            <div class="headNav">
                <img class="collapse" src="../assets/images/collapse.png" @click="toggleMenuCollapse()">
                <div class="head-right">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            {{auth.username}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">注销</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="content">
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        data() {
            return {
                menuCollapse: false,
            }
        },
        created: function () {

        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        methods: {
            ...mapMutations("auth", ["clearLoginInfo"]),
            clearPage: function() {
              sessionStorage.setItem("page", 1);
            },
            toggleMenuCollapse: function () {
                this.menuCollapse = !this.menuCollapse
            },
            handleCommand: function (e) {
                console.log(e);
                if (e == "logout") {
                    this.clearLoginInfo();
                    this.$router.push("/login");
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../less/layout";
</style>
